import { SelectType } from '~/components/NovosInputs/InputSelect/protocols';

export const operacao: SelectType[] = [
  { label: 'Todos', value: -1 },
  { label: 'Entradas', value: 0 },
  { label: 'Saídas', value: 1 },
];
